<template>
  <div>
    <v-timeline-item color="bluePcm" small>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Evento: Transferência
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text> <strong>Status: </strong> {{ statusObject[`${evento.status}`] }} </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <strong>Data início: </strong>
              {{ timeToDate(evento.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <strong>Centro de Custo: </strong>
              {{
                evento.centroDeCusto
                  ? `${evento.centroDeCusto.codigo} - ${evento.centroDeCusto.description}`
                  : 'Sem Centro de Custo'
              }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col cols="3">
            <v-card-text> <strong>Quem Transferiu: </strong> {{ evento.numeroOrigem }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Destino: </strong> {{ evento.numeroDestino }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Número Transferido: </strong> {{ evento.transferido }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text>
              <strong>Atendente: </strong>
              {{ verificaTronco(evento.atdCall, evento.numeroOrigem, evento.numeroDestino, '') }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider class="ma-2" />
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text>
              <strong>Concluída: </strong>
              <v-icon v-if="evento.transferencia" color="success">
                mdi-check
              </v-icon>
              <v-icon v-else color="darkRed">mdi-close</v-icon>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text> <strong>Ação: </strong> {{ showAcao(evento.acao) }} </v-card-text>
          </v-col>
          <Player
            v-if="
              ((evento.status === 'atendida' && evento.record) || (evento.status === 'naoAtendida' && evento.record)) &&
                permissaoOuvirAudio
            "
            :file="getAudio(evento.record)"
            :archive="evento.record"
            downloadable
            color="primary"
          />
        </v-row>
      </v-card>
    </v-timeline-item>
  </div>
</template>

<script>
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import { listaRelatorioChamadasMethods } from '../_utils/listaRelatorioChamadasMethods'

import Player from './Player'

export default {
  name: 'TimeLineTransferencia',
  props: {
    evento: Object,
    isFrom: {
      type: String,
      default: '',
    },
  },
  components: { Player },
  data: () => ({
    statusObject: {
      atendida: 'Atendida',
      ocupado: 'Ocupado',
      acessoNegado: 'Acesso Negado',
      naoAtendida: 'Não Atendida',
      error: 'Erro',
      outros: 'Outros',
      pending: 'Pendente',
    },
    permissaoOuvirAudio: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    if (this.isFrom && this.isFrom === 'pesquisaSatisfacao') {
      if (
        arrayPermissions.includes(process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO) ||
        arrayPermissions.includes(process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL) ||
        arrayPermissions.includes(process.env.VUE_APP_ADMINISTRADOR)
      ) {
        this.permissaoOuvirAudio = true
      }
    } else {
      if (
        arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO) ||
        arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL) ||
        arrayPermissions.includes(process.env.VUE_APP_ADMINISTRADOR)
      ) {
        this.permissaoOuvirAudio = true
      }
    }
  },

  methods: {
    ...listaRelatorioChamadasMethods,
    ...obtainUserPermissions,
  },
}
</script>
